import { createContext } from 'react';
import EditMPConfigContext from 'types/contexts/EditMPConfigContext';

export default createContext({} as EditMPConfigContext);
